import axios from 'axios';

const defaultOptions = {
    baseURL: process.env.REACT_APP_API_URL + '/api',
    headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
    },
    withCredentials: true,
};

// Create instance
const instance = axios.create(defaultOptions);

// Set the AUTH token for any request
instance.interceptors.request.use(function (config) {
    const token = localStorage.getItem('token');
    const language = localStorage.getItem('locale');
    config.headers.Authorization = token ? `Bearer ${token}` : '';
    config.headers.Language = language;
    return config;
});

// redirect to logout if session expired
instance.interceptors.response.use((response) => response, (error) => {
    if (error.response && error.response.status === 401) {
        localStorage.setItem('destination', window.location.pathname);
        window.location = '/logout';
    } else {
        return Promise.reject(error)
    }
});

export default instance;
